import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import * as uuid from "uuid";

const Checkbox = ({
  className,
  checked,
  children,
  disabled,
  inline,
  name,
  onChange,
  onClick,
  type,
  value,
  title,
  defaultChecked
}) => {
  const checkType = useMemo(() => (!type || type === "toggle" ? "switch" : type), [type]);
  const groupName = useMemo(() => (type === "radio" ? undefined : name || uuid.v4()), [name, type]);

  return useMemo(
    () => (
      <Form.Check
        className={className}
        id={uuid.v4()}
        name={groupName}
        type={checkType}
        disabled={disabled}
        value={value}
        defaultChecked={defaultChecked}
        onChange={(e) => onChange?.(e)}
        onClick={(e) => onClick?.(e)}
        checked={checked}
        label={children}
        title={title ? title : children && typeof children === "string" ? children : undefined}
        inline={inline}
      />
    ),
    [inline, checked, checkType, children, value, onChange, onClick, groupName, disabled, className, defaultChecked, title]
  );
};

Checkbox.propTypes = {
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.oneOf(["checkbox", "toggle", "radio"]),
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  title: PropTypes.string,
};

export default Checkbox;
